export const pageViewEvent = (title?: string, loc?: string, path?: string): void => {
	if (window.dataLayer && window.gtag) {
		const id = window.dataLayer[1][1];
		window.gtag('event', 'page_view', {
			page_title: title ? title : document.title,
			page_location: loc ? loc : location.href,
			page_path: path ? path : location.pathname,
			send_to: id
		});
	}
};
